import React from 'react';
import { ChevronWrapper } from 'src/ui/components/collapse/sports/05/Collapse.style';
import { FilterSecondary, FilterSecondaryPropsType } from './FilterSecondary';

interface FilterSecondaryWithDropdownPropsType extends FilterSecondaryPropsType {
    isOpen?: boolean;
}

export const FilterSecondaryWithDropdown = ({
    children,
    isOpen,
    isActive,
    ...rest
}: FilterSecondaryWithDropdownPropsType): JSX.Element => {
    return (
        <FilterSecondary
            isActive={isActive}
            filterType='dropdown'
            {...rest}
        >
            {children}
            <ChevronWrapper position={isOpen ? 'up' : 'down'} />
        </FilterSecondary>
    );
};
